module.exports = __webpack_public_path__ + "img/Next.09c04398.svg";